import { transport } from 'config/transport';

export function callApiGetNumberOfNuns(congDoanId, year) {
    return transport.get(`/congdoan/${congDoanId}/nun/soluong`, { params: { year } });
}
